import { VecVizChart } from "../../../d3charts/vecviz/VecViz";

export const VecvizChartConfig = ({
  data,
  pxRange,
  width,
  height,
  brushRef,
  setBrushRef,
  setActiveLine,
  setTooltip,
  config,
  setForceRefresh,
  forceRefresh,
  lRef,
}) => {
  return (
    <VecVizChart
      data={data}
      pxRange={pxRange}
      width={width}
      height={height}
      brushRef={brushRef}
      setBrushRef={setBrushRef}
      setActiveLine={setActiveLine}
      setTooltip={setTooltip}
      config={config}
      setForceRefresh={setForceRefresh}
      forceRefresh={forceRefresh}
      lRef={lRef}
    />
  );
};
